import { useTracker, ZigzagEvent } from '@common/log-manager';

const getUrl = () => {
  return typeof window !== 'undefined' ? window.location.href : null;
};
export const useCouponUBL = () => {
  const tracker = useTracker();

  const impressionCouponBannerUBL = (catalog_product_id: string, is_available: boolean) => {
    ZigzagEvent.subl({
      category: 'impression',
      navigation: 'product_detail',
      object_type: 'banner',
      object_id: 'seller_coupon',
      data: JSON.stringify({ catalog_product_id, status: is_available ? 'available' : 'unavailable' }),
    });
  };

  const clickCouponBannerUBL = (catalog_product_id: string, is_available: boolean) => {
    ZigzagEvent.subl({
      category: 'click',
      navigation: 'product_detail',
      object_type: 'banner',
      object_id: 'seller_coupon',
      data: JSON.stringify({ catalog_product_id, status: is_available ? 'available' : 'unavailable' }),
    });
  };

  const couponClickUBL = (catalog_product_id: string) => {
    tracker.addLog({
      category: 'click',
      navigation: 'product_detail',
      navigation_sub: {
        page_url: getUrl(),
      },
      object_type: 'button',
      object_id: 'seller_coupon',
      data: { catalog_product_id },
    });
  };

  return { impressionCouponBannerUBL, clickCouponBannerUBL, couponClickUBL };
};
